import store from 'store';
import sizeStore from 'store/sizeStore';
import tag from 'core/tag';
import scroll from 'core/scroll';
import CustomPageManager from './CustomPageManager';
class MainPageManager extends CustomPageManager {
    static itemsToWatch = [' a.product-card[data-event]:not([data-viewed]), .row-product-card[data-event]:not([data-viewed]) '];
    watchTimeout;
    io = new IntersectionObserver(this.onItemInView.bind(this), { threshold: [0.5] });
    list = {};
    resetScroll() {
        if (!document.scrollingElement)
            return;
        document.scrollingElement.scrollTop = Math.min(document.scrollingElement.scrollTop, sizeStore.notificationHeight.get());
    }
    onItemInView(entries) {
        const lists = {};
        if (this.watchTimeout)
            clearTimeout(this.watchTimeout);
        this.watchTimeout = setTimeout(() => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    const el = entry.target;
                    const inDrawer = el.closest('.drawer');
                    if (inDrawer)
                        return;
                    const event = tag.getEvent(el);
                    if (event && event.ecommerce) {
                        if (lists[event.ecommerce.item_list_name])
                            lists[event.ecommerce.item_list_name].push(event.ecommerce.items[0]);
                        else
                            lists[event.ecommerce.item_list_name] = [event.ecommerce.items[0]];
                        this.io.unobserve(el);
                        el.dataset.viewed = 'true';
                    }
                }
            }
            tag.triggerListTag(lists);
        }, 200);
    }
    watch = () => {
        this.io.disconnect();
        const elementsToWatch = document.querySelectorAll(MainPageManager.itemsToWatch.join(','));
        elementsToWatch.forEach((el) => this.io.observe(el));
    };
    removePage() {
        if (this.currentPage?.resetScroll)
            this.currentPage.resetScroll();
        else
            scroll.resetScroll();
        super.removePage();
    }
    async initializePage(...args) {
        await super.initializePage(...args);
        store.loading.set(false);
        this.watch();
    }
    extractPageInfo(page) {
        return super.extractPageInfo(page);
    }
    onRouteUpdate(...args) {
        const updated = super.onRouteUpdate(...args);
        if (updated !== true)
            return false;
    }
    cancelTransition() {
        super.cancelTransition();
        store.loading.set(false);
    }
    triggerInternalRouting(...args) {
        super.triggerInternalRouting(...args);
        store.loading.set(false);
    }
    async preloadPage(...args) {
        await super.preloadPage(...args);
        store.loading.set(false);
        this.watch();
    }
    createPage(...args) {
        this.previousPage?.modules?.content?.currentPage?.savePos?.();
        return super.createPage(...args);
    }
}
export default MainPageManager;
